import React, { useState } from 'react'
import { LayoutChangeEvent, StyleSheet, View } from 'react-native'
import { DS, DSIcon } from '../../../../design-system'

interface BadgeProps {
  label?: string
  backgroundColor?: string
  /** Optional DS icon rendered before the label (e.g. 'Check' for "Played") */
  icon?: DSIcon
}

const DEFAULT_TAIL_HALF_WIDTH = 18

export const Badge: React.FC<BadgeProps> = ({ label = '', backgroundColor = DS.palette['Brand/Orange'], icon }) => {
  // The notched tail spans the full badge width, so it grows with the label/icon
  const [tailHalfWidth, setTailHalfWidth] = useState(DEFAULT_TAIL_HALF_WIDTH)
  const onLayout = (e: LayoutChangeEvent) => setTailHalfWidth(e.nativeEvent.layout.width / 2)

  return (
    <View>
      <View onLayout={onLayout} style={[styles.container, icon && styles.withIcon, { backgroundColor }]}>
        {icon && <DS.Icon name={icon} size={14} color="Global/White" />}
        <DS.Text variant="Caption/Bold" textAlign="center" color="Global/White">
          {label}
        </DS.Text>
      </View>
      <View
        style={[
          styles.tail,
          {
            borderLeftColor: backgroundColor,
            borderRightColor: backgroundColor,
            borderLeftWidth: tailHalfWidth,
            borderRightWidth: tailHalfWidth
          }
        ]}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: DS.palette['Brand/Orange'],
    padding: DS.spacing[4],
    alignItems: 'center',
    justifyContent: 'center'
  },
  withIcon: {
    flexDirection: 'row',
    gap: DS.spacing[4]
  },
  tail: {
    borderTopWidth: 0,
    borderBottomWidth: 4,
    borderRightWidth: DEFAULT_TAIL_HALF_WIDTH,
    borderLeftWidth: DEFAULT_TAIL_HALF_WIDTH,
    borderBottomColor: 'transparent',
    borderLeftColor: DS.palette['Brand/Orange'],
    borderRightColor: DS.palette['Brand/Orange'],
    backgroundColor: 'transparent'
  }
})
